import { MotionNodeAnimationOptions } from 'motion-dom';
import { AnimatePresence, motion } from 'motion/react';
import React, { PropsWithChildren } from 'react';

type Props = {
  animate?: MotionNodeAnimationOptions['animate'];
  animateHeight?: boolean;
  deletionAnimation?: boolean;
  exit?: MotionNodeAnimationOptions['exit'];
  initial?: MotionNodeAnimationOptions['initial'];
  isPresent?: boolean;
  transition?: MotionNodeAnimationOptions['transition'];
};

export const AnimationPresenceWrapper: React.FC<Props & PropsWithChildren> = props => {
  const {
    animate,
    animateHeight,
    children,
    deletionAnimation,
    exit,
    initial,
    isPresent,
    transition,
  } = props;

  const isPresentParsed = isPresent ?? true;

  if (animateHeight) {
    return (
      <AnimatePresence mode="wait">
        {isPresentParsed && (
          <motion.div
            animate={{ height: 'auto', scaleY: 1 }}
            exit={{ height: 0, scaleY: 1 }}
            initial={{ height: 0, scaleY: 1 }}
            style={{ overflow: 'hidden' }}
            transition={transition ?? { duration: 0.3 }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  if (deletionAnimation) {
    return (
      <AnimatePresence mode="wait">
        {isPresentParsed && (
          <motion.div
            animate={animate ?? { opacity: 1, x: 0 }}
            exit={exit ?? { opacity: 0, x: 300 }}
            initial={initial ?? { opacity: 1, x: 0 }}
            transition={transition ?? { duration: 0.5, ease: 'easeOut' }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  return (
    <AnimatePresence mode="wait">
      {isPresentParsed && (
        <motion.div
          animate={animate ?? { opacity: 1, y: 0 }}
          exit={exit ?? { opacity: 0, y: -20 }}
          initial={initial ?? { opacity: 0, y: 150 }}
          transition={transition ?? { duration: 1 }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
